import { defineMessages } from 'react-intl'

const scope = `procurify.components.ExporterProcessingStatus`

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'We are preparing your CSV. Check back in a bit.',
  },
  description1: {
    id: `${scope}.description1`,
    defaultMessage:
      'The export will continue to process in the background even when you leave this page.',
  },
  description2: {
    id: `${scope}.description2`,
    defaultMessage: 'You can always check the {link} list for the progress.',
  },
  preparingButtonText: {
    id: `${scope}.preparingButtonText`,
    defaultMessage: 'Preparing your CSV',
  },
  downloadButtonText: {
    id: `${scope}.downloadButtonText`,
    defaultMessage: 'Download CSV',
  },
  exportErrButtonText: {
    id: `${scope}.exportErrButtonText`,
    defaultMessage: 'Export has stopped',
  },
  exportStatusQueueing: {
    id: `${scope}.exportStatusQueueing`,
    defaultMessage: 'Queueing...',
  },
  exportStatusCompleted: {
    id: `${scope}.exportStatusCompleted`,
    defaultMessage: 'Completed',
  },
  exportStatusError: {
    id: `${scope}.exportStatusError`,
    defaultMessage: 'An error has occurred due to large data export',
  },
  exportProgressLabel: {
    id: `${scope}.exportProgressLabel`,
    defaultMessage: 'Export Progress',
  },
  viewRequestCsvLinkText: {
    id: `${scope}.viewRequestCsvLinkText`,
    defaultMessage: 'View Requested CSVs',
  },
})
